import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CompactShareButton from './CompactShareButton';
import { formatEngagementCount } from '../utils/contentEngagement';

function VillageNewsGrid({ news, villageName }) {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const filteredNews = selectedCategory
    ? news.filter(article => article.category === selectedCategory)
    : news;

  const categories = [...new Set(news.map(article => article.category))];

  return (
    <div className="news-grid-section">
      <h2 className="section-title"> {villageName} की खबरें</h2>

      {/* Category Filter */}
      <div style={{marginBottom: '20px', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
        <button
          onClick={() => setSelectedCategory(null)}
          style={{
            padding: '6px 12px',
            borderRadius: '4px',
            border: selectedCategory === null ? '2px solid #FF7A00' : '1px solid #ddd',
            background: selectedCategory === null ? '#FF7A00' : 'white',
            color: selectedCategory === null ? 'white' : '#333',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 'bold',
            transition: 'all 0.3s ease'
          }}
        >
          सभी खबरें
        </button>
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            style={{
              padding: '6px 12px',
              borderRadius: '4px',
              border: selectedCategory === category ? '2px solid #FF7A00' : '1px solid #ddd',
              background: selectedCategory === category ? '#FF7A00' : 'white',
              color: selectedCategory === category ? 'white' : '#333',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
          >
            {category}
          </button>
        ))}
      </div>

      {/* News Grid */}
      <div className="news-grid">
        {filteredNews.map(article => {
          const articleId = article._id || article.id;

          return (
            <article key={articleId} className="news-card">
              <Link to={`/village-news/${articleId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="news-card-image">
                <img src={article.image} alt={article.headline} />
                <span className="news-card-category">{article.category}</span>
                </div>
              </Link>
              <div className="news-card-content">
                <h3 className="news-card-headline">
                  <Link to={`/village-news/${articleId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {article.headline}
                  </Link>
                </h3>
                <p className="news-card-description">{article.description}</p>
                <div className="news-card-meta">
                  <span>{article.date}</span>
                  <span> {formatEngagementCount(article.views)} views</span>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <CompactShareButton
                    title={article.headline}
                    url={`/village-news/${articleId}`}
                    description={article.description}
                    contentId={articleId}
                  />
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}

export default VillageNewsGrid;
